import React from 'react';

function Accordion({ children }) {
  return <div className="accordion">{children}</div>;
}

export default Accordion;
